import { Show, onMount } from "solid-js";
import { CMS } from "../components/cms/cms";
import { Progress } from "../components/progress";
import { loadSponsorsCms } from "../app";
import { createStore } from "solid-js/store";

type State = {
    isContentReady: boolean;
}
export function SponsorsPage() {
    const [state, setState] = createStore<State>({ isContentReady: false });
    onMount(async() => {
        await loadSponsorsCms();
        setState({ isContentReady: true });
    });
    return (
        <>
            <Show when={state.isContentReady}>
                <div class="article">
                    <div class="container">
                        <Progress step={0} />
                        <CMS id="18th-salon-application/sponsors::page-body"></CMS>
                    </div>
                </div>
            </Show>
        </>
    )
}